import Image from "next/image";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import FacebookIcon from "../../../../public/images/icons/fb-r.png";
import TwitterIcon from "../../../../public/images/icons/twitter-r.png";
import ShareIcon from "../../../../public/images/icons/link-r.png";
import styles from "../../../styles/candidate/parts/CandidateSocialButtons.module.scss";
import { useState } from "react";

const loader = ({ src, width, quality }) => {
  return `${src}?w=${width}&q=${quality || 75}`;
};

const SocialBtns = ({
  containerStyle,
  iconContainerStyle,
  url,
  anchor,
  fbQuote,
  twQuote,
  customLoader = loader,
}) => {
  const [isTooltipToggled, setTooltipToggle] = useState(false);

  const closeTooltip = () => {
    setTooltipToggle(false);
  };

  const copyLink = () => {
    setTooltipToggle(true);

    const el = document.createElement("input");
    el.value = `${url}#${anchor}`;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);

    setTimeout(() => {
      setTooltipToggle(false);
    }, 2500);
  };

  return (
    <div className={containerStyle}>
      <FacebookShareButton url={`${url}#${anchor}`} quote={fbQuote}>
        <div className={iconContainerStyle}>
          <Image
            loader={customLoader}
            src={FacebookIcon}
            alt="facebook"
            layout="responsive"
            width={25}
            height={25}
          />
        </div>
      </FacebookShareButton>
      <TwitterShareButton url={`${url}#${anchor}`} title={twQuote}>
        <div className={iconContainerStyle}>
          <Image
            loader={loader}
            src={TwitterIcon}
            alt="twitter"
            layout="responsive"
            width={25}
            height={20}
          />
        </div>
      </TwitterShareButton>
      <div className={`${iconContainerStyle} ${styles.candidateSocialButton}`}>
        {isTooltipToggled && (
          <div className={styles.tooltip} onClick={() => closeTooltip()}>
            Copied!
          </div>
        )}
        <Image
          loader={loader}
          src={ShareIcon}
          alt="share"
          layout="responsive"
          width={25}
          height={25}
          onClick={() => copyLink()}
        />
      </div>
    </div>
  );
};

export default SocialBtns;
